import { render, staticRenderFns } from "./BulkUpdateFeedback.vue?vue&type=template&id=07ae074f&"
import script from "./BulkUpdateFeedback.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateFeedback.vue?vue&type=script&lang=js&"
import style0 from "./BulkUpdateFeedback.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports